import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';

import {
  AmplitudeFixedUserProperty,
  AmplitudeVariableUserProperty,
  User,
} from 'src/interfaces/iuser';
import { useIsLoggedIn } from './useCustomHooks';

export const useIdentifyAmplitudeUser = () => {
  const isLoggedIn = useIsLoggedIn();
  const user: User = useSelector(state => (state as any).dashboard.user);

  const location = useLocation();
  const searchParams = location.search;
  const pageQuery = new URLSearchParams(searchParams).get('page') || '';
  const referrer = document.referrer;

  useEffect(() => {
    if (isLoggedIn && user && !user.loading && user.email != 'Trial') {
      const userEmail = user.email;
      amplitude.setUserId(userEmail);

      const fixedUserProperty: AmplitudeFixedUserProperty = {
        email: user.email,
        name: user.userName,
        description: user.userDescription,
        subDescription: user.userSubDescription,
        signupDate: user.userSignUpDay,
        signupTimestamp: user.signupTimestamp,
        signupCountryCode: user.signupCountryCode,
        signupIpAddress: user.signupIpAddress,
        referrer: pageQuery ? pageQuery : referrer,
      };

      const variableUserProperty: AmplitudeVariableUserProperty = {
        role: user.role,
        customerId: user.customerID,
        subscriptionPlan: user.subscriptionPlan,
      };

      const identifyEvent = new amplitude.Identify();

      // static properties that will be set just once in amplitude
      Object.entries(fixedUserProperty).forEach(([key, value]) => {
        if (value !== undefined) {
          identifyEvent.setOnce(key, value);
        }
      });

      // these properties can be updated/added
      Object.entries(variableUserProperty).forEach(([key, value]) => {
        if (value !== undefined) {
          identifyEvent.set(key, value);
        }
      });

      amplitude.identify(identifyEvent as any);
    }
  }, [user, isLoggedIn]);
};
